import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Any render crash would otherwise unmount everything and leave a white
// screen. Show the error and a way out instead.
class ErrorBoundary extends React.Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error(error, info.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24, fontFamily: "sans-serif", textAlign: "center" }}>
        <h1 style={{ fontSize: 22, margin: 0 }}>Something went wrong</h1>
        <p style={{ color: "#64748b", margin: 0 }}>တစ်ခုခု မှားယွင်းနေပါသည်</p>
        <pre style={{ fontSize: 12, color: "#94a3b8", whiteSpace: "pre-wrap", maxWidth: 600 }}>{String(this.state.error)}</pre>
        <button onClick={() => window.location.reload()} style={{ padding: "12px 28px", fontSize: 16, borderRadius: 8, border: "none", background: "#2563eb", color: "#fff", cursor: "pointer" }}>
          Reload
        </button>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
  });
}
